
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Spinner, ToggleControl } from "@wordpress/components";
import classNames from "classnames";
import { isString } from "lodash";

const BlockCard = ({ block, isLoading, onToggle }) => {
  return (
    <div className="ubs-block-card">
      <div
        className={classNames("ubs-block-card__icon", {
          // "is-disabled": block?.isPro && !ultrablocksObj?.hasPro,
        })}
      >
        {block.icon?.()}
        {/* {block.icon ? (
          <span className={`dashicons dashicons-${block.icon}`} />
        ) : (
        )} */}
      </div>
      <div className="ubs-block-card__description">
        <h3>{block.name}</h3>
        <a
          href={
            block?.docLink ??
            "https://docs.themeisle.com/category/1611-blocks-library"
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </a>
        {/* {block?.isPro && !ultrablocksObj?.hasPro && (
          <Fragment>
            |
            <a
              href={ultrablocksObj.upgradeLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__("Get Pro", "ultrablocks")}
            </a>
          </Fragment>
        )} */}
      </div>
      <div className="ubs-block-card__action">
        {
        block?.released ? (
          <ToggleControl checked={!block?.isDisabled} onChange={onToggle} />
        ): (
          <span className="ubs-block-comming">{__("Coming", "ultrablocks")}</span>
        )
        }

        {/* {isLoading ? (
          <Spinner />
        ) : block?.isPro &&
          !(ultrablocksObj?.hasPro && "valid" === ultrablocksObj?.license.valid) ? (
          <span className="ubs-block-upsell">{__("Pro", "ultrablocks")}</span>
        ) : (
        )} */}
      </div>
    </div>
  );
};

export default BlockCard;
